<main>
  <div class="ks-card ks-mb-1">
    <div class="ks-card-body insights-body">
      <div class="insights-container">
        <div class="insight-card">
          <header class="insight-header ks-mb-1">
            <div class="ks-font-weight-medium ks-text-neutral">Success Rate</div>
            <div class="ks-font-weight-bold ks-font-size-lg">
              {{ getRate(insights.successRate) }}%
            </div>
          </header>
          <footer class="ks-mt-4">
            <div
              class="ks-font-size-sm ks-text-{{
                getMonthChangesRateColor(insights.monthOverMonthChange)
              }}"
            >
              {{ getMonthChangesRate(insights.monthOverMonthChange) }}% from last month
            </div>
          </footer>
        </div>

        <div class="insight-card">
          <header class="insight-header ks-mb-1">
            <label class="ks-font-weight-medium ks-text-neutral">Total transactions</label>
            <label class="ks-font-weight-bold ks-font-size-lg">{{ totalTransaction }}</label>
          </header>
          <footer>
            <div class="transaction-filter-input">
              <kt-autocomplete
                [label]="'Total for'"
                [color]="'neutral'"
                [control]="totalTransactionFilter"
                [optionsType]="'LIST'"
                [options]="totalTransactionFilterOptions"
                [optionType]="'PRIMITIVE'"
                [size]="'sm'"
              ></kt-autocomplete>
            </div>
          </footer>
        </div>
        <div class="insight-card">
          <header class="insight-header ks-mb-1">
            <label class="ks-font-weight-medium ks-text-neutral">Failed transactions</label>
            <label class="ks-font-weight-bold ks-font-size-lg">{{ totalFailedTransaction }}</label>
          </header>
        </div>

        <div class="insight-card">
          <header class="insight-header ks-mb-1">
            <div class="ks-font-weight-medium ks-text-neutral">Total transaction</div>
            <div class="ks-font-weight-bold ks-font-size-lg">{{ totalTransactionNotFiltered }}</div>
          </header>
        </div>
      </div>
    </div>
  </div>
</main>
